import React from 'react';
import Error from '../components/error-not-found';
import Footer from '../components/footer';
import '../styles/not-found.css';

function notFound() {
    window.scrollTo(0, 0);
    return (
        <div>
            <div className='NotFound'>
            <Error />
            </div>
            <Footer className='Footer'/>
        </div>
    )
}

export default notFound